/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An external issuer an organization trusts to vouch for its workloads.
 */
export type WorkloadIssuer = {
  /**
   * Whether subjects under this issuer may be admitted by a wildcard rule.
   */
  allowWildcardAdmission: boolean;
  createdAt: Date;
  /**
   * What the platform is and what runs on it. Empty rather than absent where none is set.
   */
  description: string;
  /**
   * The workload issuer id.
   */
  id: string;
  /**
   * The issuer identifier the assertion's iss claim must carry.
   */
  issuer: string;
  /**
   * Where the issuer publishes its signing keys.
   */
  jwksUri: string;
  /**
   * The label an operator works with.
   */
  name: string;
  /**
   * The owning organization id.
   */
  organizationId: string;
  /**
   * The owning project id; empty for an organization-tier issuer.
   */
  projectId: string;
  /**
   * Free-form labels for grouping and filtering trusted platforms. Empty rather than absent where none are set.
   */
  tags: Array<string>;
  updatedAt: Date;
};

/** @internal */
export const WorkloadIssuer$inboundSchema: z.ZodMiniType<
  WorkloadIssuer,
  unknown
> = z.pipe(
  z.object({
    allow_wildcard_admission: z.boolean(),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.string(),
    id: z.string(),
    issuer: z.string(),
    jwks_uri: z.string(),
    name: z.string(),
    organization_id: z.string(),
    project_id: z.string(),
    tags: z.array(z.string()),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "allow_wildcard_admission": "allowWildcardAdmission",
      "created_at": "createdAt",
      "jwks_uri": "jwksUri",
      "organization_id": "organizationId",
      "project_id": "projectId",
      "updated_at": "updatedAt",
    });
  }),
);

export function workloadIssuerFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadIssuer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadIssuer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadIssuer' from JSON`,
  );
}
